// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class TransferSummaryConstants {
  static TransferTitle: string = 'Transfer Details';
  static AgentDisconnectTitle: string = 'Previous agent lost connection';
}
